import { render } from "./StoreSharedDashboardView.vue?vue&type=template&id=02d04d87"
import script from "./StoreSharedDashboardView.vue?vue&type=script&lang=js"
export * from "./StoreSharedDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__